import React from 'react';
import { useMetaPixel } from './lib/useMetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/sections/Hero';
import { Stats } from './components/sections/Stats';
import { Problem } from './components/sections/Problem';
import { Vision } from './components/sections/Vision';
import { Comparison } from './components/sections/Comparison';
import { PainPoints } from './components/sections/PainPoints';
import { Contents } from './components/sections/Contents';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  useMetaPixel();
  return <div className="w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="3ihuyk4ft23e4">
      <main data-id="element-1" data-mp="3mkho1yp07c85">
        <Hero data-id="element-2" data-mp="3mjzsl4a6121a" />
        <Stats data-id="element-3" data-mp="3mjpyb4i388ps" />
        <Problem data-id="element-4" data-mp="3mj6j3vjtnyfg" />
        <Vision data-id="element-5" data-mp="3rcj8i7wbs999" />
        <Comparison data-id="element-6" data-mp="3rbzo8kj7d8s2" />
        <PainPoints data-id="element-7" data-mp="3rdkl4gszp3t3" />
        <Contents data-id="element-8" data-mp="3recf5n6xuth9" />
        <Bonuses data-id="element-9" data-mp="5yjetptzbev" />
        <Offer data-id="element-10" data-mp="6hrlipoilfp" />
        <Guarantee data-id="element-11" data-mp="4wvvprmowg9" />
        <Testimonials data-id="element-12" data-mp="5gfrc0u9uwx" />
        <About data-id="element-13" data-mp="82j0zgp5o9c" />
        <Faq data-id="element-14" data-mp="2zl3brl12165b" />
        <FinalCta data-id="element-15" data-mp="2zllff2q1qmn9" />
      </main>
      <Footer data-id="element-16" data-mp="2zmeo498kfm81" />
      <FloatingCta data-id="element-17" data-mp="2zmwi0z7r9ocs" />
      <PurchaseToast data-id="element-18" data-mp="2zng0ch1bierc" />
    </div>;
}